var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEmptyStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1216"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 348",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 191",
    d: "M26.457 8.375 20.093 7.5a1.932 1.932 0 0 1-1.456-1l-2.846-5.478a1.981 1.981 0 0 0-3.467 0L9.477 6.494a1.932 1.932 0 0 1-1.456 1l-6.364.878A1.81 1.81 0 0 0 .586 11.5l4.606 4.258a1.781 1.781 0 0 1 .556 1.624L4.659 23.4a1.914 1.914 0 0 0 2.8 1.932l5.694-2.839a2.03 2.03 0 0 1 1.8 0l5.692 2.839a1.913 1.913 0 0 0 2.8-1.932l-1.087-6.014a1.777 1.777 0 0 1 .556-1.624l4.615-4.262a1.81 1.81 0 0 0-1.072-3.128",
    transform: "translate(.587 1.536)",
    style: {
      fill: "#e5e5e5"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyStar);
export default __webpack_public_path__ + "static/media/ic-empty-star.fa2d6a3693b44b4f1a4926c9876a6b6d.svg";
export { ForwardRef as ReactComponent };